export class renameSetCategori {
    indexCat: number;
    name: string;
    constructor(indexCat,name) {
this.indexCat = indexCat;
this.name = name;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/rename/rename-set-categori.ts